import {Input, Space} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {FormFieldError} from "../../../../../../../design-system/form-field";
import type {SubSettingsFormFieldsType} from "../../types";

export function SubSettingsPurchaseLimitValueFormField() {
  const {watch, control} = useFormContext<SubSettingsFormFieldsType>();
  const limitUnitsPerTransaction = watch("limitUnitsPerTransaction");

  return (
    <div>
      {limitUnitsPerTransaction && (
        <Controller
          control={control}
          name="purchaseLimit"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <Input
                status={error?.message ? "error" : ""}
                onChange={onChange}
                onBlur={onBlur}
                size="large"
                value={value === null ? undefined : value}
                placeholder="0"
                ref={ref}
              />
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    </div>
  );
}
